module.exports = __webpack_public_path__ + "images/img-1AlRS6q.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/ranks/2.jpg
// module id = 2029
// module chunks = 0